import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { getLinkedOrgs, getSelectedProfileId } from '../selectors/OrgManagementSelectors';
import RepeatIcon from '../../../img/sprite/repeat-icon.svg';
import css from '../../../css/css-variables.json';
import { UserProfileLink, OrgProfileLink } from '../components/OrgManagement/ProfileLink';
import { matchPath } from 'react-router';
import { ORG_PATHS } from '../constants';

const Box = styled.div`
  margin-top: auto;
  border-top: 2px solid ${css.colors.AccentGray};
  border-bottom: 2px solid ${css.colors.AccentGray};

  overflow-y: scroll;

  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar{
    display:none;
  }

  @media(max-width: 720px) {
    margin-top: 1rem;
    padding: 8px 0 0 0;

    border-bottom: 0 none;
  }
`;

const Header = styled.h3`
  border-bottom: 2px solid ${css.colors.AccentGray};

  margin: 0;
  padding: ${css.gutter3};
  text-align: center;

  color: #333333;
  font-size: ${css.fontSize.medium};
  font-weight: normal;

  & svg {
    margin-right: .5em;
    margin-bottom: 2px;
  }

  @media(max-width: 720px) {
    border-bottom: 0 none;
    text-align: start;
    padding: 0 0 8px 0;
  }
`;

const ProfileList = styled.ul`
  margin: 0 auto;
  padding: ${css.gutter3};
  width: fit-content;

  font-size: ${css.fontSize.small};

  @media(max-width: 720px) {
    margin: 0;
    padding: 0;
  }
`;


export const SwitchProfile = ({
  userId,
  firstName,
  initials,
  initialsColor,
  linkedOrganizations,
  selectedProfileId,
  location,
  navToggle,
}) => {
  const onOrgRoute = matchPath(location.pathname, { path: ORG_PATHS.BASE }) != null;

  if (!onOrgRoute && linkedOrganizations.length < 1) {
    return null;
  }

  return (
    <Box>
      <Header>
        <svg><use href={`#${RepeatIcon.id}`} /></svg>
        Switch Profiles
      </Header>
      <ProfileList>
        {userId &&
          <li>
            <UserProfileLink
              userId={userId}
              selectedProfileId={selectedProfileId}
              firstName={firstName}
              initials={initials}
              initialsColor={initialsColor}
              onClick={navToggle}
            />
          </li>
        }
        {linkedOrganizations.map(organization => (
          <li key={organization.organizationId}>
            <OrgProfileLink
              {...organization}
              selectedProfileId={selectedProfileId}
              onClick={navToggle}
            />
          </li>
        ))}
      </ProfileList>
    </Box>
  );
};


const { arrayOf, shape, string, func } = PropTypes;

SwitchProfile.propTypes = {
  userId: string,
  firstName: string,
  initials: string,
  initialsColor: string,
  linkedOrganizations: arrayOf(shape({
    organizationId: string.isRequired,
    organizationName: string.isRequired,
    initials: string,
    initialsColor: string,
  })),
  selectedProfileId: string,
  location: shape({
    pathname: string.isRequired
  }).isRequired,
  navToggle: func
};

const mapStateToProps = (state) => {
  return {
    userId: state.app.getIn(['currentUser', 'id']),
    firstName: state.app.getIn(['currentUser', 'firstName']),
    initials: state.app.getIn(['currentUser', 'initials']),
    initialsColor: state.app.getIn(['currentUser', 'initialsColor']),
    linkedOrganizations: getLinkedOrgs(state),
    selectedProfileId: getSelectedProfileId(state),
    location: state.router.location
  };
};
const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(SwitchProfile);
